<script setup lang="ts">
type Props = {
  src: string;
  height?: number;
  width?: number;
};

const { src, height = 50, width = 120 } = defineProps<Props>();
</script>
<template>
  <iframe
    :height="height"
    scrolling="no"
    :src="src"
    style="border: none"
    title="CuracaoGaming Iframe"
    :width="width"
  ></iframe>
</template>
